function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.75 3C5.75 2.86193 5.86193 2.75 6 2.75H18C18.1381 2.75 18.25 2.86193 18.25 3V19.8535C18.25 20.0659 18.0018 20.1815 17.8392 20.0449L13.1258 16.0841C12.4749 15.5371 11.5251 15.5371 10.8742 16.0841L6.16083 20.0449L6.64334 20.619L6.16083 20.0449C5.9982 20.1815 5.75 20.0659 5.75 19.8535V3Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgBookmark = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBookmark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Bookmark.04da46fa.svg";
export { ForwardRef as ReactComponent };